<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
    <v-card style="border: black 2px solid">
      <v-card-title class="headline mb-1">
        <span> ตั้งค่าข้อมูลบันทึกแผนข้อมูลประจำปี</span>
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item>
            <v-row>
              <v-col
                  cols="12"
                  md="4">
                <v-text-field type="date" label="วันที่เริ่มต้น"
                              v-model="dateStart"
                              :error="dateStart == ''"
                              :error-messages="dateStart == '' ? 'วันที่สิ้นสุด (ห้ามว่าง)' : ''"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  md="4">
                <v-text-field type="date" label="วันที่สิ้นสุด"
                              v-model="dateEnd"
                              :error="dateEnd == ''"
                              :error-messages="dateEnd == '' ? 'วันที่สิ้นสุด (ห้ามว่าง)' : ''"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  md="4">
                <v-autocomplete
                    v-model="FiscalYear"
                    label="แผนประจำปี"
                    :items="FiscalYearData"
                    item-text="yearth"
                    item-value="year"
                    :error-messages="FiscalYear == '' ? 'แผนประจำปี (ห้ามว่าง)' : ''"
                    persistent-hint
                    :error="FiscalYear == null"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-row class="d-flex justify-center">
              <v-col
                  cols="12"
                  md="10">
                <v-data-table
                    style="width: 100%"
                    :items="DateForPlan"
                    :headers="headerDateForPlan">
                  <template v-slot:item.date_start="{item}">
                    {{ item.date_start | dateToThai }}
                  </template>
                  <template v-slot:item.date_end="{item}">
                    {{ item.date_end | dateToThai }}
                  </template>
                  <template v-slot:item.year="{item}">
                    {{ item.year | YearToThai }}
                  </template>
                  <template v-slot:item.action="{item}">
                    <v-btn
                        class="ma-2"
                        text
                        icon
                        color="red lighten-2"
                        @click="deleteDate(item.id)"
                    >
                      <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
        <div align="center">
          <v-btn dark @click="saveDateForPlan">บันทึกข้อมูล</v-btn>
        </div>
      </v-card-text>
    </v-card>
    </template>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";

export default {
  name: "SettingDateForPlan",
  data() {
    return {
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      dateStart: '',
      dateEnd: '',
      FiscalYear: null,
      CheckAdmin: false,
      CheckSubAdmin: false,
      FiscalYearData: [],
      datePlan: [],
      headerDateForPlan: [
        {text: 'วันที่เริ่มต้น', value: 'date_start'},
        {text: 'วันที่สิ้นสุด', value: 'date_end'},
        {text: 'แผนประจำปี', value: 'year'},
        {text: '', value: 'action'},
      ]
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      PermissionApprove: 'Permission/getPermissionApprove',
      PermissionUserApprove: 'Permission/getPermissionUserApprove',
      OptPermission: 'Permission/getOptPermission',
      getOptUserPermission: 'Permission/getOptUserPermission',
      DateForPlan: 'Project/getDateForPlan',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      getPermissionData: 'Permission/getPermissionData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      initDateForPlan: 'Project/initDateForPlan',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
      changeTypeProject: 'Project/changeTypeProject',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
    }),
    init() {
      this.initDateForPlan()
      if ((new Date().getMonth() + 1) >= 10) {
        for (var i = new Date().getFullYear() + 2; i <= (new Date().getFullYear() + 2); i++) {
          this.FiscalYearData.push({
            year: i,
            yearth: i + 543
          })
        }
      } else {
        for (i = new Date().getFullYear() + 1; i <= (new Date().getFullYear() + 2); i++) {
          this.FiscalYearData.push({
            year: i,
            yearth: i + 543
          })
        }
      }
    },
    saveDateForPlan() {
      this.CheckPermission().then(async resPermiss => {
        if (resPermiss) {
          if (this.dateStart != '' && this.dateEnd != '' && this.FiscalYear != null) {
            if (this.dateStart > this.dateEnd) {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'กรอกวันที่เริ่มต้น และ วันที่สิ้นสุดไม่ถูกต้อง!!',
              })
            } else if (this.DateForPlan.length > 0 && this.DateForPlan.filter(item => (item.date_start <= this.dateStart && item.date_end >= this.dateStart && item.year == this.FiscalYear) || (item.date_start <= this.dateEnd && item.date_end >= this.dateEnd && item.year == this.FiscalYear)).length > 0) {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'พบข้อมูลในระบบอยู่แล้ว!!',
              })
            } else {
              await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Date_plan', {
                date_start: this.dateStart,
                date_end: this.dateEnd,
                year: this.FiscalYear,
                create_by: this.MeData[0].perid,
                create_time: 'now()',
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'PUT'
                }
              }).then(res => {
                if (res.data.status) {
                  this.dateStart = ''
                  this.dateEnd = ''
                  this.FiscalYear = null
                  this.$swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูลสำเร็จ !!!',
                  })
                  this.init()
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'ไม่สามารถบันทึกข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ',
                  })
                }
              })
            }
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'วันที่เริ่มต้น, วันที่สิ้นสุด, แผนประจำปี ห้ามว่าง !!',
            })
          }
        } else {
          this.btnDisable = false
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    deleteDate(id) {
      this.CheckPermission().then(async resPermiss => {
        if (resPermiss) {
          await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Date_plan/id/' + id, {
            active: '0',
            update_by: this.MeData[0].perid
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => {
            if (res.data.status) {
              this.$swal.fire({
                icon: 'success',
                title: 'ลบข้อมูลสำเร็จ !!!',
              })
              this.init()
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถลบข้อมูลได้ โปรดลองอีกครั้ง',
              })
            }
          })
        } else {
          this.btnDisable = false
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '14001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '14001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
  },
  mounted() {
    this.changeColor({
      color: ConstData.defaultColorApp
    })
    this.changeHeaderName({
      headerName: ConstData.defaultHeaderApp
    })
    this.changeTypeProject({
      type: null
    })
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '22'
        })

        this.getMenuPermissData().then(res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '22' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
              this.maintain = false
              this.getPermissionData({
                perid: this.MeData[0].perid
              }).then(resAdmin => {
                if (resAdmin) {
                  this.PermissionAdmin.map((Per_i, idx) => {
                    if (Per_i.permission_id == '14000') {
                      this.CheckAdmin = true
                      this.init()
                    } else {
                      if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                        this.$router.push('/')
                      }
                    }
                  })
                } else {
                  this.getPermissionUserData({
                    perid: this.MeData[0].perid
                  }).then(resUser => {
                    if (resUser) {
                      this.Permission.map((Per_i, idx) => {
                        if (Per_i.permission_id == '14000') {
                          this.CheckSubAdmin = true
                          this.init()
                        } else {
                          if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                            this.$router.push('/')
                          }
                        }
                      })
                    } else {
                      this.CheckSubAdmin = false
                      this.CheckAdmin = false
                      this.$router.push('/')
                    }
                  })
                }
              })
            } else {
              this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '22' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '22')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
              this.maintain = true
            }
          }
        }).then(err => {
          if (err) {
            this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '22' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '22')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
            this.maintain = true
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>

</style>
